import {RefObject, useState} from "react";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {addNotification} from "@/features/notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "@/features/notifications/utils/error_notifications";
import {useHomeMatchPreferences} from "@/features/user/hooks/use_home_match_preferences";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";

import {DEFAULT_HOME_MATCH_BASIC_CONSENT} from "../../constants/home_match_survey_defaults";
import {getHomeMatchConfigurationSourceSection, HomeMatchConfigurationSourceSectionTrigger} from "../../utils/get_home_match_configuration_source_section";
import {HomeMatchPreferencesWizardStep} from "../../utils/get_home_match_preferences_wizard_steps";

interface IParams {
    hasNextStep: boolean;
    isSaving: boolean;
    onAdvance: () => void;
    onDone: () => void;
    patchSaved: () => Promise<unknown>;
    preferencesSurveySource: PreferencesSurveySource;
    saveInFlightRef: RefObject<boolean>;
    trackSaved: (savedStep: HomeMatchPreferencesWizardStep, autoMatchEnabled?: boolean) => void;
}

export const useHomeMatchPreferencesWizardSummary = (params: IParams) => {
    const {hasNextStep, isSaving, onAdvance, onDone, patchSaved, preferencesSurveySource, saveInFlightRef, trackSaved} = params;
    const dispatch = useAppDispatch();
    const {isSwitchingHomeMatchPreferences, switchHomeMatchPreferences} = useHomeMatchPreferences();
    const [consent, setConsent] = useState(DEFAULT_HOME_MATCH_BASIC_CONSENT);

    const resetConsent = () => setConsent(DEFAULT_HOME_MATCH_BASIC_CONSENT);

    const confirmSummary = async () => {
        if (saveInFlightRef.current || isSaving || isSwitchingHomeMatchPreferences) return;

        saveInFlightRef.current = true;
        let didPatch = false;

        try {
            await patchSaved();
            didPatch = true;
            trackSaved(HomeMatchPreferencesWizardStep.SUMMARY, consent);

            const didSaveHomeMatch = await switchHomeMatchPreferences(consent, {
                // A phone step after the summary handles the verification; without one the user needs feedback.
                onPhoneVerificationRequired: hasNextStep ? undefined : () => dispatch(addNotification(defaultAPIErrorNotification)),
                showSuccessNotification: false,
                sourceSection: getHomeMatchConfigurationSourceSection({
                    preferencesSurveySource,
                    trigger: HomeMatchConfigurationSourceSectionTrigger.SUMMARY_MODAL
                }),
                skipPhoneVerificationPrompt: true,
                syncCplPreferences: false
            });

            if (hasNextStep) return onAdvance();

            if (didSaveHomeMatch) onDone();
        } catch {
            if (!didPatch) dispatch(addNotification(defaultAPIErrorNotification));
        } finally {
            saveInFlightRef.current = false;
        }
    };

    return {confirmSummary, consent, isSwitching: isSwitchingHomeMatchPreferences, resetConsent, setConsent};
};
import {RefObject, useState} from "react";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {addNotification} from "@/features/notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "@/features/notifications/utils/error_notifications";
import {useHomeMatchPreferences} from "@/features/user/hooks/use_home_match_preferences";
import {useAppDispatch} from "@/store/hooks/use_app_dispatch";

import {DEFAULT_HOME_MATCH_BASIC_CONSENT} from "../../constants/home_match_survey_defaults";
import {getHomeMatchConfigurationSourceSection, HomeMatchConfigurationSourceSectionTrigger} from "../../utils/get_home_match_configuration_source_section";
import {HomeMatchPreferencesWizardStep} from "../../utils/get_home_match_preferences_wizard_steps";

interface IParams {
    hasNextStep: boolean;
    isSaving: boolean;
    onAdvance: () => void;
    onDone: () => void;
    patchSaved: () => Promise<unknown>;
    preferencesSurveySource: PreferencesSurveySource;
    saveInFlightRef: RefObject<boolean>;
    trackSaved: (savedStep: HomeMatchPreferencesWizardStep, autoMatchEnabled?: boolean) => void;
}

export const useHomeMatchPreferencesWizardSummary = (params: IParams) => {
    const {hasNextStep, isSaving, onAdvance, onDone, patchSaved, preferencesSurveySource, saveInFlightRef, trackSaved} = params;
    const dispatch = useAppDispatch();
    const {isSwitchingHomeMatchPreferences, switchHomeMatchPreferences} = useHomeMatchPreferences();
    const [consent, setConsent] = useState(DEFAULT_HOME_MATCH_BASIC_CONSENT);

    const resetConsent = () => setConsent(DEFAULT_HOME_MATCH_BASIC_CONSENT);

    const confirmSummary = async () => {
        if (saveInFlightRef.current || isSaving || isSwitchingHomeMatchPreferences) return;

        saveInFlightRef.current = true;
        let didPatch = false;

        try {
            await patchSaved();
            didPatch = true;
            trackSaved(HomeMatchPreferencesWizardStep.SUMMARY, consent);

            const didSaveHomeMatch = await switchHomeMatchPreferences(consent, {
                // A phone step after the summary handles the verification; without one the user needs feedback.
                onPhoneVerificationRequired: hasNextStep ? undefined : () => dispatch(addNotification(defaultAPIErrorNotification)),
                showSuccessNotification: false,
                sourceSection: getHomeMatchConfigurationSourceSection({
                    preferencesSurveySource,
                    trigger: HomeMatchConfigurationSourceSectionTrigger.SUMMARY_MODAL
                }),
                skipPhoneVerificationPrompt: true,
                syncCplPreferences: false
            });

            if (hasNextStep) return onAdvance();

            if (didSaveHomeMatch) onDone();
        } catch {
            if (!didPatch) dispatch(addNotification(defaultAPIErrorNotification));
        } finally {
            saveInFlightRef.current = false;
        }
    };

    return {confirmSummary, consent, isSwitching: isSwitchingHomeMatchPreferences, resetConsent, setConsent};
};
